
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import IconItem from '@/components/main/IconsMenu/IconItem';
    import { convertMdiBracketToIcon } from '@/mdi';

    @Component
    export default class IconsMenu extends Vue {
        @Prop(Array) items: IconItem[];
        @Prop({ default: null }) menuName: string;
        @Prop({ default: null }) menuTitle: string;
        @Prop({ default: true }) showMenu: boolean;

        private convertMdiBracketToIcon = convertMdiBracketToIcon;

        public getItems() {
            return this.items.filter(item => item.enabled);
        }

        private select(e: PointerEvent, index: number) {
            var button: HTMLButtonElement = e.target;
            button.blur();

            var item: IconItem = this.getItems()[index];

            item.otherIcons.forEach(otherIcon => {
                if (otherIcon != item && otherIcon.selected) {
                    otherIcon.hide();
                }
            });

            if (!item.selected) {
                item.hideMenu = this.hideIconMenu;
                item.button = button;
                item.select();
            } else {
                item.deselect();
                item.button = undefined;
                item.hideMenu = undefined;
            }
            
            
            
        }

        private showIconMenu() {
            const className = ".tbdc-icon-menu-" + this.menuName;

            document.querySelectorAll(".tbdc-icon-menu" + className + " .tbdc-icon-menu-dropdown" + ".tbdc-icon-menu-hidden").forEach(element => element.classList.remove("tbdc-icon-menu-hidden"))
        }

        private hideIconMenu() {
            const className = ".tbdc-icon-menu-" + this.menuName;
            document.querySelectorAll(".tbdc-icon-menu" + className + " .tbdc-icon-menu-dropdown").forEach(element => element.classList.add("tbdc-icon-menu-hidden"));
        }
    }
